var _g, _rect, _path, _g2, _rect2, _path2, _rect3, _path3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceActivityIndex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 145,
    viewBox: "0 0 287 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11400_12683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 102C58.6731 102 73 87.6731 73 70C73 52.3269 58.6731 38 41 38C23.3269 38 9 52.3269 9 70C9 87.6731 23.3269 102 41 102Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5152 57.4356C43.9446 57.9264 42.4722 58.908 41.1961 60.0859C39.8219 58.908 38.4477 57.9264 36.8771 57.4356C31.0857 55.6687 26.1777 61.1657 26.1777 66.5644C26.1777 76.773 39.0366 87.0798 41.1961 87.0798C43.3556 87.0798 56.2145 76.8712 56.2145 66.5644C56.2145 61.1657 51.1103 55.6687 45.5152 57.4356Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.334,
    y: 38,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFB925"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.334 71.3539L131.437 51.9736H146.461L142.104 64.8938H150.667L133.541 90.7342L135.644 71.3539H129.334Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11400_12683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.001 110.001C255.092 110.001 273.001 92.0924 273.001 70.001C273.001 47.9096 255.092 30.001 233.001 30.001C210.91 30.001 193.001 47.9096 193.001 70.001C193.001 92.0924 210.91 110.001 233.001 110.001Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.155 76.7498L237.787 75.8909C236.315 73.5597 235.578 70.2468 235.333 66.8112C234.965 58.8357 237.787 52.5781 242.327 52.21H242.572C246.621 52.21 250.302 57.8541 250.916 65.5842C251.161 69.0198 250.67 72.21 249.689 74.7866L249.443 75.6455H248.584C247.112 75.4001 245.272 75.4001 243.922 75.6455C242.327 75.6455 240.609 76.1363 239.259 76.5044L238.155 76.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.97 74.5399L228.338 73.681C229.811 71.3497 230.547 68.0368 230.792 64.6012C231.16 56.6258 228.338 50.3681 223.798 50H223.676C219.627 50 215.946 55.6442 215.332 63.3742C215.087 66.8098 215.577 70 216.559 72.5767L216.804 73.4356H217.541C219.013 73.1902 220.854 73.1902 222.203 73.4356C223.798 73.4356 225.516 73.9264 226.866 74.2945L227.97 74.5399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.063 90.1233C239.627 90.1233 237.296 86.0742 237.541 81.1663C237.541 80.7982 237.541 80.1847 237.541 79.8166L237.787 78.835L248.707 79.2031V80.3074C248.707 80.6755 248.707 81.2889 248.707 81.657C248.829 86.4423 246.253 90.1233 243.063 90.1233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.941 87.9143C226.377 87.9143 228.708 83.8652 228.463 78.9573C228.463 78.5892 228.463 77.9757 228.463 77.6076L228.217 76.626L217.297 76.9941V77.9757C217.297 78.3438 217.297 78.9573 217.297 79.3254C217.174 84.1106 219.874 87.9143 222.941 87.9143Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 100L165.5 104L172.5 96",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 100L69.5 104L76.5 96",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 118,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 18,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 143.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 39.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.5,
    cy: 42.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187 7.5L197.5 25",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 21L263.5 4.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 126L247.5 142",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11400_12683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(9 38)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11400_12683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(193 30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceActivityIndex);
export default __webpack_public_path__ + "static/media/persistence-activity-index.d107fd6b9bc7de9e7b26ef2fea880cde.svg";
export { ForwardRef as ReactComponent };